// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.header {
  /* position: relative; */
  background-color: #F3F7F9;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 2.8vw;
  font-family: 'Roboto', sans-serif;
  font-weight: bold;
  color: white;
}

.login_input {
  position: absolute;
  background-color: #6C6BAE;
  top: 25%;
  left: 40%;
  width: 20vw;
  height: 50vh;
  font-size: 2vw;
  border-radius: 1vw;
  border: 0.2vw solid #646464;
}

.login_text {
  position: absolute;
  background-color: #6C6BAE;
  top: 27vh;
  left: 45vw;
  width: 10%;
  height: 10%;
  display: flex;
  flex-direction: column;
  align-items: center; /* ตำแหน่งแนวนอน */
  justify-content: flex-start; /* ตำแหน่งแนวตั้ง */
  font-size: 3vw;
  font-family: 'Roboto', sans-serif;
  color: #ffffff;
}

.input_box_username {
  padding: 1.5vh;
  border-radius: 0.5vw;
  border: 0.3vh solid #ccc;
  font-size: 1vw;
  width: 16vw; /* ทำให้ input ขยายเต็มภายใน login_text */
  box-sizing: border-box;
}

.input_box_password {
  padding: 1.5vh;
  border-radius: 0.5vw;
  border: 0.3vh solid #ccc;
  font-size: 1vw;
  width: 16vw; /* ทำให้ input ขยายเต็มภายใน login_text */
  box-sizing: border-box;
}

.backsign {
  position: absolute;
  background-color: #6C6BAE;
  top: 65%;
  left: 0%;
  width: 100%;
  height: 20%;
  display: flex;
  flex-direction: column;
  align-items: center; /* ตำแหน่งแนวนอน */
  justify-content: flex-start; /* ตำแหน่งแนวตั้ง */
  font-size: 3vw;
  font-family: 'Roboto', sans-serif;
  color: #ffffff;
}


.ok {
  position: absolute;
  background-color: #F3F7F9;
  top: 25%;
  left: 53%;
  width: 42%;
  height: 50%;
  display: flex;
  flex-direction: column;
  align-items: center; /* ตำแหน่งแนวนอน */
  justify-content: center; /* ตำแหน่งแนวตั้ง */
  font-size: 1vw;
  font-family: 'Roboto', sans-serif;
  color: #2F343B;
  border: 0.1vw solid #646464;
  border-radius: 0.5vw;
}

.back {
  position: absolute;
  background-color: #F3F7F9;
  top: 25%;
  left: 5%;
  width: 42%;
  height: 50%;
  display: flex;
  flex-direction: column;
  align-items: center; /* ตำแหน่งแนวนอน */
  justify-content: center; /* ตำแหน่งแนวตั้ง */
  font-size: 1vw;
  font-family: 'Roboto', sans-serif;
  color: #2F343B;
  border: 0.1vw solid #646464;
  border-radius: 0.5vw;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 768px) {
  .login_input {
    position: absolute;
    background-color: #6C6BAE;
    top: 10vh;
    left: 20vw;
    width: 60vw;
    height: 80vh;
    font-size: 2vw;
    border-radius: 1vh;
    border: 0.4vh solid #646464;
  }

  .login_text {
    position: absolute;
    background-color: #6C6BAE;
    top: 20vh;
    left: 35vw;
    width: 30vw;
    height: 10vh;
    display: flex;
    flex-direction: column;
    align-items: center; /* ตำแหน่งแนวนอน */
    justify-content: flex-start; /* ตำแหน่งแนวตั้ง */
    font-size: 8vh;
    font-family: 'Roboto', sans-serif;
    color: #ffffff;
  }

  .input_box_username {
    position: absolute;
    padding: 1.5vh;
    border-radius: 1vh;
    border: 0.4vh solid #ccc;
    font-size: 2.5vh;
    top: 15vh;
    left: 5vw;
    width: 50vw;
    height: 8vh;
    box-sizing: border-box;
    z-index: 1;
  }

  .input_box_password {
    position: absolute;
    padding: 1.5vh;
    border-radius: 1vh;
    border: 0.4vh solid #ccc;
    font-size: 2.5vh;
    top: 40vh;
    left: 5vw;
    width: 50vw;
    height: 8vh;
    box-sizing: border-box;
    z-index: 1;
  }

  .backsign {
    position: absolute;
    background-color: #6C6BAE;
    top: 60vh;
    left: 0vw;
    width: 60vw;
    height: 15vh;
    display: flex;
    flex-direction: column;
    align-items: center; /* ตำแหน่งแนวนอน */
    justify-content: flex-start; /* ตำแหน่งแนวตั้ง */
    font-size: 3vw;
    font-family: 'Roboto', sans-serif;
    color: #ffffff;
  }

  .ok {
    position: absolute;
    background-color: #F3F7F9;
    top: 3vh;
    left: 32vw;
    width: 25vw;
    height: 7.5vh;
    display: flex;
    flex-direction: column;
    align-items: center; /* ตำแหน่งแนวนอน */
    justify-content: center; /* ตำแหน่งแนวตั้ง */
    font-size: 2.5vh;
    font-family: 'Roboto', sans-serif;
    color: #2F343B;
    border: 0.3vh solid #646464;
    border-radius: 1vh;
  }

  .back {
    position: absolute;
    background-color: #F3F7F9;
    top: 3vh;
    left: 2vw;
    width: 25vw;
    height: 7.5vh;
    display: flex;
    flex-direction: column;
    align-items: center; /* ตำแหน่งแนวนอน */
    justify-content: center; /* ตำแหน่งแนวตั้ง */
    font-size: 2.5vh;
    font-family: 'Roboto', sans-serif;
    color: #2F343B;
    border: 0.3vh solid #646464;
    border-radius: 1vh;
  }

  .error_text {
    position: absolute;
    top: 65vh;
    left: 15vw;
    font-size: 3.4vh;
    font-family: 'Roboto', sans-serif;
    width: 70vw;
    color: red;
  }
}`, "",{"version":3,"sources":["webpack://./src/Login.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iCAAiC;EACjC,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,SAAS;EACT,UAAU;EACV,UAAU;EACV,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB,EAAE,kBAAkB;EACvC,2BAA2B,EAAE,mBAAmB;EAChD,cAAc;EACd,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,wBAAwB;EACxB,cAAc;EACd,WAAW,EAAE,yCAAyC;EACtD,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,wBAAwB;EACxB,cAAc;EACd,WAAW,EAAE,yCAAyC;EACtD,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB,EAAE,kBAAkB;EACvC,2BAA2B,EAAE,mBAAmB;EAChD,cAAc;EACd,iCAAiC;EACjC,cAAc;AAChB;;;AAGA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB,EAAE,kBAAkB;EACvC,uBAAuB,EAAE,mBAAmB;EAC5C,cAAc;EACd,iCAAiC;EACjC,cAAc;EACd,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,QAAQ;EACR,QAAQ;EACR,UAAU;EACV,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB,EAAE,kBAAkB;EACvC,uBAAuB,EAAE,mBAAmB;EAC5C,cAAc;EACd,iCAAiC;EACjC,cAAc;EACd,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,yBAAyB;IACzB,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;IACzB,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB,EAAE,kBAAkB;IACvC,2BAA2B,EAAE,mBAAmB;IAChD,cAAc;IACd,iCAAiC;IACjC,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,wBAAwB;IACxB,gBAAgB;IAChB,SAAS;IACT,SAAS;IACT,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,wBAAwB;IACxB,gBAAgB;IAChB,SAAS;IACT,SAAS;IACT,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;IACzB,SAAS;IACT,SAAS;IACT,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB,EAAE,kBAAkB;IACvC,2BAA2B,EAAE,mBAAmB;IAChD,cAAc;IACd,iCAAiC;IACjC,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;IACzB,QAAQ;IACR,UAAU;IACV,WAAW;IACX,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB,EAAE,kBAAkB;IACvC,uBAAuB,EAAE,mBAAmB;IAC5C,gBAAgB;IAChB,iCAAiC;IACjC,cAAc;IACd,2BAA2B;IAC3B,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;IACzB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB,EAAE,kBAAkB;IACvC,uBAAuB,EAAE,mBAAmB;IAC5C,gBAAgB;IAChB,iCAAiC;IACjC,cAAc;IACd,2BAA2B;IAC3B,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,iCAAiC;IACjC,WAAW;IACX,UAAU;EACZ;AACF","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.header {\n  /* position: relative; */\n  background-color: #F3F7F9;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: 2.8vw;\n  font-family: 'Roboto', sans-serif;\n  font-weight: bold;\n  color: white;\n}\n\n.login_input {\n  position: absolute;\n  background-color: #6C6BAE;\n  top: 25%;\n  left: 40%;\n  width: 20vw;\n  height: 50vh;\n  font-size: 2vw;\n  border-radius: 1vw;\n  border: 0.2vw solid #646464;\n}\n\n.login_text {\n  position: absolute;\n  background-color: #6C6BAE;\n  top: 27vh;\n  left: 45vw;\n  width: 10%;\n  height: 10%;\n  display: flex;\n  flex-direction: column;\n  align-items: center; /* ตำแหน่งแนวนอน */\n  justify-content: flex-start; /* ตำแหน่งแนวตั้ง */\n  font-size: 3vw;\n  font-family: 'Roboto', sans-serif;\n  color: #ffffff;\n}\n\n.input_box_username {\n  padding: 1.5vh;\n  border-radius: 0.5vw;\n  border: 0.3vh solid #ccc;\n  font-size: 1vw;\n  width: 16vw; /* ทำให้ input ขยายเต็มภายใน login_text */\n  box-sizing: border-box;\n}\n\n.input_box_password {\n  padding: 1.5vh;\n  border-radius: 0.5vw;\n  border: 0.3vh solid #ccc;\n  font-size: 1vw;\n  width: 16vw; /* ทำให้ input ขยายเต็มภายใน login_text */\n  box-sizing: border-box;\n}\n\n.backsign {\n  position: absolute;\n  background-color: #6C6BAE;\n  top: 65%;\n  left: 0%;\n  width: 100%;\n  height: 20%;\n  display: flex;\n  flex-direction: column;\n  align-items: center; /* ตำแหน่งแนวนอน */\n  justify-content: flex-start; /* ตำแหน่งแนวตั้ง */\n  font-size: 3vw;\n  font-family: 'Roboto', sans-serif;\n  color: #ffffff;\n}\n\n\n.ok {\n  position: absolute;\n  background-color: #F3F7F9;\n  top: 25%;\n  left: 53%;\n  width: 42%;\n  height: 50%;\n  display: flex;\n  flex-direction: column;\n  align-items: center; /* ตำแหน่งแนวนอน */\n  justify-content: center; /* ตำแหน่งแนวตั้ง */\n  font-size: 1vw;\n  font-family: 'Roboto', sans-serif;\n  color: #2F343B;\n  border: 0.1vw solid #646464;\n  border-radius: 0.5vw;\n}\n\n.back {\n  position: absolute;\n  background-color: #F3F7F9;\n  top: 25%;\n  left: 5%;\n  width: 42%;\n  height: 50%;\n  display: flex;\n  flex-direction: column;\n  align-items: center; /* ตำแหน่งแนวนอน */\n  justify-content: center; /* ตำแหน่งแนวตั้ง */\n  font-size: 1vw;\n  font-family: 'Roboto', sans-serif;\n  color: #2F343B;\n  border: 0.1vw solid #646464;\n  border-radius: 0.5vw;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@media (max-width: 768px) {\n  .login_input {\n    position: absolute;\n    background-color: #6C6BAE;\n    top: 10vh;\n    left: 20vw;\n    width: 60vw;\n    height: 80vh;\n    font-size: 2vw;\n    border-radius: 1vh;\n    border: 0.4vh solid #646464;\n  }\n\n  .login_text {\n    position: absolute;\n    background-color: #6C6BAE;\n    top: 20vh;\n    left: 35vw;\n    width: 30vw;\n    height: 10vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center; /* ตำแหน่งแนวนอน */\n    justify-content: flex-start; /* ตำแหน่งแนวตั้ง */\n    font-size: 8vh;\n    font-family: 'Roboto', sans-serif;\n    color: #ffffff;\n  }\n\n  .input_box_username {\n    position: absolute;\n    padding: 1.5vh;\n    border-radius: 1vh;\n    border: 0.4vh solid #ccc;\n    font-size: 2.5vh;\n    top: 15vh;\n    left: 5vw;\n    width: 50vw;\n    height: 8vh;\n    box-sizing: border-box;\n    z-index: 1;\n  }\n\n  .input_box_password {\n    position: absolute;\n    padding: 1.5vh;\n    border-radius: 1vh;\n    border: 0.4vh solid #ccc;\n    font-size: 2.5vh;\n    top: 40vh;\n    left: 5vw;\n    width: 50vw;\n    height: 8vh;\n    box-sizing: border-box;\n    z-index: 1;\n  }\n\n  .backsign {\n    position: absolute;\n    background-color: #6C6BAE;\n    top: 60vh;\n    left: 0vw;\n    width: 60vw;\n    height: 15vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center; /* ตำแหน่งแนวนอน */\n    justify-content: flex-start; /* ตำแหน่งแนวตั้ง */\n    font-size: 3vw;\n    font-family: 'Roboto', sans-serif;\n    color: #ffffff;\n  }\n\n  .ok {\n    position: absolute;\n    background-color: #F3F7F9;\n    top: 3vh;\n    left: 32vw;\n    width: 25vw;\n    height: 7.5vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center; /* ตำแหน่งแนวนอน */\n    justify-content: center; /* ตำแหน่งแนวตั้ง */\n    font-size: 2.5vh;\n    font-family: 'Roboto', sans-serif;\n    color: #2F343B;\n    border: 0.3vh solid #646464;\n    border-radius: 1vh;\n  }\n\n  .back {\n    position: absolute;\n    background-color: #F3F7F9;\n    top: 3vh;\n    left: 2vw;\n    width: 25vw;\n    height: 7.5vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center; /* ตำแหน่งแนวนอน */\n    justify-content: center; /* ตำแหน่งแนวตั้ง */\n    font-size: 2.5vh;\n    font-family: 'Roboto', sans-serif;\n    color: #2F343B;\n    border: 0.3vh solid #646464;\n    border-radius: 1vh;\n  }\n\n  .error_text {\n    position: absolute;\n    top: 65vh;\n    left: 15vw;\n    font-size: 3.4vh;\n    font-family: 'Roboto', sans-serif;\n    width: 70vw;\n    color: red;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
